const siteConfig = {
  name: "Skincare by Jannine",
  social: {
    instagram: "https://www.instagram.com/jannineskincare/"
  },
  contactEmail: "contact@jannineskincare.com",
  address: "Eatontown, New Jersey",
  contactPhone: "732-991-6730"
}

export default siteConfig;